import type {
  CopilotPageContext,
  CopilotPageHint,
} from "@/features/copilot/lib/copilot-page-context";

/**
 * Holds the page context and which pages the user dismissed, outside React, so the
 * send-time getter keeps one identity for the life of the provider and the chat
 * transport is never rebuilt when the page changes.
 */
export function createCopilotPageHintGate() {
  let current: CopilotPageContext | null = null;
  const dismissedIdentities = new Set<string>();

  return {
    setContext(context: CopilotPageContext | null): void {
      current = context;
    },
    dismiss(identity: string): void {
      dismissedIdentities.add(identity);
    },
    isDismissed(identity: string): boolean {
      return dismissedIdentities.has(identity);
    },
    readHint(): CopilotPageHint | null {
      return current && !dismissedIdentities.has(current.identity) ? current.hint : null;
    },
  };
}
